module.exports = __webpack_public_path__ + "img/join-lo-top-bg.832353ed.png";